import styled from 'styled-components';

export const Spin = styled.span`
  font-size: 30px !important;
  z-index: 1000;
  i {
    width: 15px;
    height: 15px;
  }
`;

export const Message = styled.span`
  font-size: 18px;
  font-weight: bold;
  margin-top: 60px;
  z-index: 1000;
`;
